import { useContext, useState, useEffect } from 'react';

import { updateDoctor } from '../../actions/mainForm';
import { form4Validator } from '../../validators/MainFormValidator';
import { doctorHandleChange } from '../../helpers/handlers/doctorHandler';

import useFetchHook from '../../hooks/customHook';

import { DataContext } from '../../context/DataContext';

import {
    Button, Dialog, DialogActions, DialogContent,
    DialogTitle, Grid2, TextField, FormControl,
    InputLabel, Select, MenuItem
} from '@mui/material';

import { regex_phone } from '../../constants/regex';

const MedicoDialog = ({
    open, setDialogStatus, doctor, setDoctor, setMedicos
}) => {
    const { data: { specialties, promoters }, setData } = useContext(DataContext);
    const { protectedFetchReq } = useFetchHook();

    const { name, professionalID, email, phone, especialidad, promotor_name } = doctor;

    const [fieldError, setFieldError] = useState({
        phone_err: false 
    });
    const { phone_err } = fieldError;
    
    useEffect(() => {
        setFieldError(
            e => ({
                ...e, phone_err: regex_phone.test(phone) ? false : true
            })
        );
    }, [phone]);

    const handleClose = () => {
        setDialogStatus(e => ({ ...e, dialog1: false }));
    };

    const handleChange = ({ target }) => {
        doctorHandleChange(target, setDoctor);
    };

    const updateDoctorFn = async () => {
        if (form4Validator(doctor))
            await updateDoctor(doctor, setMedicos, handleClose, setData, protectedFetchReq);
    };

    return (
        <Dialog
            open={open}
            onClose={ handleClose }
            aria-labelledby="doctor-dialog-title"
            aria-describedby="doctor-dialog-description"
            sx={{ zIndex: 1000 }}
        >
            <DialogTitle id="doctor-dialog-title">
                Información del Médico
            </DialogTitle>
            <DialogContent>
                <Grid2 container spacing={4} sx={{ pt: 2 }}>
                    <Grid2 size={{ xl: 6, lg: 6, md: 6, sm: 12, xs: 12 }}>
                        <TextField label='Nombre'
                            variant='outlined'
                            fullWidth
                            size='small'
                            name='name'
                            value={name}
                            onChange={handleChange}
                        />
                    </Grid2>

                    <Grid2 size={{ xl: 6, lg: 6, md: 6, sm: 12, xs: 12 }}>
                        <TextField label='Cédula profesional' variant='outlined' fullWidth size='small' name='professionalID' value={professionalID} onChange={handleChange}
                            slotProps={{ htmlInput: { maxLength: 8 } }}
                        />
                    </Grid2>

                    <Grid2 size={{ xl: 6, lg: 6, md: 6, sm: 12, xs: 12 }}>
                        <TextField label='Correo electrónico' variant='outlined' fullWidth size='small' name='email' value={email} onChange={handleChange} />
                    </Grid2>

                    <Grid2 size={{ xl: 6, lg: 6, md: 6, sm: 12, xs: 12 }}>
                        <TextField label='Teléfono' variant='outlined' fullWidth size='small' name='phone' value={phone} onChange={handleChange}
                            slotProps={{ htmlInput: { maxLength: 10 } }} helperText={ phone_err ? "Introduzca un número válido" : "" }
                        />
                    </Grid2>

                    <Grid2 size={{ xl: 6, lg: 6, md: 6, sm: 12, xs: 12 }}>
                        <FormControl fullWidth size='small'>
                            <InputLabel id="especialidad">Seleccione una especialidad</InputLabel>
                            <Select
                                labelId="especialidad"
                                label="Seleccione una especialidad"
                                name='especialidad'
                                value={especialidad}
                                onChange={handleChange}
                            >

                                {
                                    specialties.map(({ idEspecialidad, nombreEspecialidad }) =>
                                        <MenuItem key={idEspecialidad}
                                            value={idEspecialidad}>
                                            { nombreEspecialidad }
                                        </MenuItem>
                                    )
                                }
                            </Select>
                        </FormControl>
                    </Grid2>

                    <Grid2 size={{ xl: 6, lg: 6, md: 6, sm: 12, xs: 12 }}>
                        {/* <TextField label='Promotor' variant='outlined' fullWidth size='small' name='promotor_name' value={promotor_name}
                            disabled
                        /> */}
                        <FormControl fullWidth size='small'>
                            <InputLabel id="promotor">Promotor de venta</InputLabel>
                            <Select
                                labelId="promotor"
                                label="Promotor de venta"
                                name='promotor_name'
                                value={promotor_name}
                                onChange={handleChange}
                            >

                                {
                                    promoters.map((e) =>
                                        <MenuItem key={e}
                                            value={e}>
                                            { e }
                                        </MenuItem>
                                    )
                                }
                            </Select>
                        </FormControl>
                    </Grid2>
                </Grid2>
            </DialogContent>
            <DialogActions>
            <Button onClick={ handleClose }>Cancelar</Button>
            <Button onClick={ updateDoctorFn } autoFocus>
                Actualizar
            </Button>
            </DialogActions>
        </Dialog>
    );
};

export default MedicoDialog;